import React, { useState } from 'react';
import { Button } from 'reactstrap';

export const TemplateCardButtons = ({
  isPremium,
  onTogglePremium,
}) => {
  const [premium, setPremium] = useState(isPremium);

  return (
    <div style={styles.templateCardButtonsContainer}>
      <h5 style={styles.premiumTitle(premium)}>{premium ? 'Premium' : 'Not premium'}</h5>
      <Button
        style={styles.premiumButton}
        color="primary"
        type="button"
        onClick={() => {
          onTogglePremium(!premium);
          setPremium(!premium);
        }}
      >
        {premium ? 'Not premium' : 'Premium'}
      </Button>
    </div>
  );
};

const TemplateCard = ({
  item: template,
  itemSelected,
  dragHandleProps,
}) => {
  const scale = itemSelected * 0.05 + 1;
  const shadow = itemSelected * 15 + 1;

  return (
    <div
      style={{
        display: 'flex',
        transform: `scale(${scale})`,
        boxShadow: `rgba(0, 0, 0, 0.1) 0px ${shadow}px ${2 * shadow}px 0px`,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...dragHandleProps}
    >
      <div style={styles.imageContainer}>
        <img alt="template" src={template.thumbnailEn} style={styles.image} />
      </div>
    </div>
  );
};

const styles = {
  image: {
    height: 180,
    width: 240,
  },
  imageContainer: {
    marginVertical: 30,
  },
  templateCardButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  premiumTitle: (premium) => ({
    color: premium ? 'green' : 'red',
    marginRight: 20,
  }),
  premiumButton: {
    height: 50,
  },
};

export default TemplateCard;



// WEBPACK FOOTER //
// ./src/components/templates-manager/categories-components/TemplateCard.js